import React from 'react';
import { Grid } from '@material-ui/core';
import AppearanceSettings from '../../components/Settings/AppearanceSettings';
import UserSettings from '../../components/Settings/UserSettings';
import DataSettings from '../../components/Settings/DataSettings';

export const UserSettingsPage = () => {
  return (
    <Grid container spacing={4} style={{ padding: '2rem', width: '100%' }}>
      <Grid item xs={12} md={4}>
        <AppearanceSettings />
      </Grid>
      <Grid item xs={12} md={4}>
        <DataSettings />
      </Grid>
      <Grid item xs={12} md={4}>
        <UserSettings />
      </Grid>
    </Grid>
  );
};
